import Components from "slotworks/components/components";
import GameState from "slotworks/model/game-state";
import { Services } from "slotworks/services/services";
import State from "slotworks/state-machine/states/state";

export default class RecoverGamble extends State {
    public onEnter() {
        Components.alert.recover().then(() => {
            const gameplay = GameState.getCurrentGame();
            const recordWin = gameplay.getCurrentRecord().cashWon;
            const totalWin = gameplay.getTotalWin();
            Services.transaction.setWinnings(recordWin, totalWin).then(() => this.complete());
        });
    }
}
